export default "__VITE_ASSET__CZ0BP2C___"